import { render, staticRenderFns } from "./DeleteServerButton.vue?vue&type=template&id=41d60249&scoped=true"
import script from "./DeleteServerButton.vue?vue&type=script&lang=js"
export * from "./DeleteServerButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteServerButton.vue?vue&type=style&index=0&id=41d60249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d60249",
  null
  
)

export default component.exports